import Loader from "../common/Loader/Loader";
import TemplateTile from "./TemplateTile";
import useGetSasTokenForTile from "../../utils/useGetSasTokenForTile";

const SelfVerificationTemplates = ({ templateData }) => {
    const [sasToken, loading] = useGetSasTokenForTile();

    if (loading) return <Loader />;

    return (
        <div className="tiles-container col-sm-12 col-md-12 col-lg-12">
            {templateData &&
                templateData.map((tile) => (
                    <TemplateTile
                        tile={tile}
                        templateData={templateData}
                        sasToken={sasToken}
                    />
                ))}
        </div>
    );
};

export default SelfVerificationTemplates;
